import { render } from "./SkillsTableHeader.vue?vue&type=template&id=bc6d8022&ts=true"
import script from "./SkillsTableHeader.vue?vue&type=script&lang=ts"
export * from "./SkillsTableHeader.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__